import { useEffect, useState } from 'react';
import { AddressWrapper } from '@/components/Address-Wrapper';
import useStore from '@/store/store';
import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import Button from '@/ui/button/Button';

export const ClientAddresses = ({ address: initAddress, onSaveAddress }) => {
	const { user } = useStore();

	// const [clientS, setClientS] = useState();
	// const [clientD, setClientD] = useState('');
	// const [clientF, setClientF] = useState('');
	console.log('gamo', initAddress);
	const [address, setAddress] = useState({
		street: initAddress?.s || '',
		doorbell: initAddress?.d || '',
		floor: initAddress?.f || '',
		location: {
			lat: initAddress?.l?.lat || null,
			lng: initAddress?.l?.lng || null,
		},
	});

	const [errorAddress, setErrorAddress] = useState(false);
	const saveDisabled = () => errorAddress === undefined || errorAddress;
	// console.log('address LOGGER ', address, errorAddress);

	return (
		<div className='flex flex-col'>
			<AddressWrapper
				user={user}
				label='Διεύθυνση'
				withinServiceArea
				address={address}
				setAddress={e => {
					// console.log('edoo koitao', e);
					setAddress(e);
				}}
				errorAddress={errorAddress}
				setErrorAddress={setErrorAddress}
			/>

			<div className='flex flex-row items-center gap-x-2'>
				<div className='flex-4/6'>
					<FloatingTextinput
						value={address.doorbell}
						label='Κουδούνι'
						onChange={e => setAddress({ ...address, doorbell: e })}
						white
						size='full'
					/>
				</div>
				<div className='flex-2/6'>
					<FloatingTextinput
						value={address.floor}
						label='Όροφος'
						onChange={e => setAddress({ ...address, floor: e })}
						white
						size='full'
					/>
				</div>
			</div>
			<Button onClick={() => onSaveAddress(address)} disabled={saveDisabled()} text='Αποθήκευση' />
		</div>
	);
};
